import * as React from 'react';
import styles from './file-uploader.scss';

export interface FileItemProgressProps {
  progress?: number;
  indeterminate?: boolean;
}

export const FileItemProgress = (props:FileItemProgressProps) => (
  <div className={styles.progress}>
    {props.indeterminate ?
      <div className={styles.indeterminate}/> :
      <div className={styles.determinate} style={{ width: Math.min(props.progress, 100) + '%' }} />
    }
  </div>
);
